"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8328],{

/***/ 15071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ TagButton; },
/* harmony export */   "U": function() { return /* binding */ TagButtonGroup; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70917);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4807);
/* harmony import */ var _lib_url__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48261);






var TagButton = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("li", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("display:inline-block;margin:0 4px 4px 0;"),
        "data-test-id": "tag",
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
            href: _lib_url__WEBPACK_IMPORTED_MODULE_3__/* .TAG_HREF */ .cS,
            as: "slug" in props.tag ? (0,_lib_url__WEBPACK_IMPORTED_MODULE_3__/* .newTagPath */ .w6)(props.tag) : props.tag.path,
            passHref: true,
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("a", {
                "data-test-id": "tag-link",
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("background-color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.gray40 */ .O9.gray40, ";border-radius:3px;padding:2px 6px;font-size:12px;line-height:1.5;color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.gray90 */ .O9.gray90, ";text-align:center;display:block;white-space:nowrap;transition:0.3s;&:hover{color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.white00 */ .O9.white00, ";background-color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.gray70 */ .O9.gray70, ";}"),
                className: "tag-button ".concat(props.className ? props.className : ""),
                children: "#".concat(props.tag.name)
            })
        })
    });
};
var TagButtonGroup = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("ul", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("margin:0 0 -4px;padding:0;"),
        className: props.className,
        "data-test-id": props.dataTestId,
        children: props.children
    });
};


/***/ }),

/***/ 58124:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B1": function() { return /* binding */ addMyLabel; },
/* harmony export */   "E1": function() { return /* binding */ unfollowCompany; },
/* harmony export */   "Kd": function() { return /* binding */ getContactPersons; },
/* harmony export */   "Mn": function() { return /* binding */ fetchCompany; },
/* harmony export */   "Q9": function() { return /* binding */ fetchCompanyChart; },
/* harmony export */   "QU": function() { return /* binding */ getCompanyContactPerson; },
/* harmony export */   "_v": function() { return /* binding */ deleteCompanyContactPerson; },
/* harmony export */   "ds": function() { return /* binding */ registerCompanyContactPerson; },
/* harmony export */   "gQ": function() { return /* binding */ fetchCompanyNewsFeed; },
/* harmony export */   "h$": function() { return /* binding */ registerCompanyStatus; },
/* harmony export */   "ih": function() { return /* binding */ fetchOverseaBenchmarkCompanies; },
/* harmony export */   "ix": function() { return /* binding */ getCompanyFollowing; },
/* harmony export */   "jI": function() { return /* binding */ registerFirstInterviewDate; },
/* harmony export */   "jy": function() { return /* binding */ getCompanyStatus; },
/* harmony export */   "lZ": function() { return /* binding */ deleteCompanyStatus; },
/* harmony export */   "nj": function() { return /* binding */ deleteFirstInterviewDate; },
/* harmony export */   "qy": function() { return /* binding */ requestDownloadCompany; },
/* harmony export */   "s9": function() { return /* binding */ followCompany; },
/* harmony export */   "t1": function() { return /* binding */ getCompanyMemo; },
/* harmony export */   "tI": function() { return /* binding */ getCompany; },
/* harmony export */   "vy": function() { return /* binding */ fetchCompanyByMyname; },
/* harmony export */   "w2": function() { return /* binding */ getCompanyStatuses; },
/* harmony export */   "xe": function() { return /* binding */ removeMyLabel; },
/* harmony export */   "zt": function() { return /* binding */ saveCompanyMemo; }
/* harmony export */ });
/* unused harmony exports getLatestCompanies, getDailyRanking */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70655);
/* harmony import */ var _log__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79240);
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6140);
/* harmony import */ var _tracking__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56902);





var getCompany = function(shortname) {
    return (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPI */ .F)("".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/companies/").concat(shortname));
};
var getLatestCompanies = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        var res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPI */ .F)("".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/companies/latest"))
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.data
                    ];
            }
        });
    });
    return function getLatestCompanies() {
        return _ref.apply(this, arguments);
    };
}();
var getDailyRanking = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        var data, res, e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    data = [];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPI */ .F)("".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/companies/ranking"))
                    ];
                case 2:
                    res = _state.sent();
                    data = res.data;
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    (0,_log__WEBPACK_IMPORTED_MODULE_4__/* .printError */ .O)(e);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function getDailyRanking() {
        return _ref.apply(this, arguments);
    };
}();
var fetchCompany = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(ctx, shortname) {
        var company, e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAuthAPI */ .rO)(ctx, "".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/pages/companies/").concat(shortname))
                    ];
                case 1:
                    company = _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    e = _state.sent();
                    (0,_log__WEBPACK_IMPORTED_MODULE_4__/* .printError */ .O)(e);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2,
                        company ? company.data : null
                    ];
            }
        });
    });
    return function fetchCompany(ctx, shortname) {
        return _ref.apply(this, arguments);
    };
}();
var fetchCompanyByMyname = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(ctx, myname) {
        var company, e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAuthAPI */ .rO)(ctx, "".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/pages/c/").concat(myname))
                    ];
                case 1:
                    company = _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    e = _state.sent();
                    (0,_log__WEBPACK_IMPORTED_MODULE_4__/* .printError */ .O)(e);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2,
                        company ? company.data : null
                    ];
            }
        });
    });
    return function fetchCompanyByMyname(ctx, myname) {
        return _ref.apply(this, arguments);
    };
}();
var fetchCompanyNewsFeed = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(shortname) {
        var options, q, res;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    q = "offset=".concat(options === null || options === void 0 ? void 0 : options.offset);
                    return [
                        4,
                        (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPI */ .F)("".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/companies/").concat(shortname, "/news_feed?").concat(q))
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res
                    ];
            }
        });
    });
    return function fetchCompanyNewsFeed(shortname) {
        return _ref.apply(this, arguments);
    };
}();
var fetchCompanyChart = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(shortname) {
        var res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPI */ .F)("".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/companies/").concat(shortname, "/chart"), {
                            credentials: "include"
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res ? res.data : null
                    ];
            }
        });
    });
    return function fetchCompanyChart(shortname) {
        return _ref.apply(this, arguments);
    };
}();
var followCompany = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(shortname) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPI */ .F)("".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/companies/").concat(shortname, "/follow"), {
                    method: "POST",
                    credentials: "include"
                })
            ];
        });
    });
    return function followCompany(shortname) {
        return _ref.apply(this, arguments);
    };
}();
var unfollowCompany = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(shortname) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPI */ .F)("".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/companies/").concat(shortname, "/unfollow"), {
                    method: "POST",
                    credentials: "include"
                })
            ];
        });
    });
    return function unfollowCompany(shortname) {
        return _ref.apply(this, arguments);
    };
}();
var getCompanyFollowing = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(shortname) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPI */ .F)("".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/companies/").concat(shortname, "/following"))
            ];
        });
    });
    return function getCompanyFollowing(shortname) {
        return _ref.apply(this, arguments);
    };
}();
var requestDownloadCompany = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(shortname, format) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPI */ .F)("".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/companies/").concat(shortname, "/export.").concat(format), {
                    method: "POST",
                    credentials: "include"
                })
            ];
        });
    });
    return function requestDownloadCompany(shortname, format) {
        return _ref.apply(this, arguments);
    };
}();
var fetchOverseaBenchmarkCompanies = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(shortname) {
        var e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPI */ .F)("".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/companies/").concat(shortname, "/oversea_benchmarks"), {
                            credentials: "include"
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
                case 2:
                    e = _state.sent();
                    (0,_log__WEBPACK_IMPORTED_MODULE_4__/* .printError */ .O)(e);
                    return [
                        2,
                        {
                            overseaBenchmarkCompanies: []
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchOverseaBenchmarkCompanies(shortname) {
        return _ref.apply(this, arguments);
    };
}();
var getCompanyStatus = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(ctx, shortname) {
        var e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAuthAPI */ .rO)(ctx, "".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/pages/companies/").concat(shortname, "/company_status"))
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
                case 2:
                    e = _state.sent();
                    (0,_log__WEBPACK_IMPORTED_MODULE_4__/* .printError */ .O)(e);
                    return [
                        2,
                        {
                            companyStatus: null
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getCompanyStatus(ctx, shortname) {
        return _ref.apply(this, arguments);
    };
}();
var getCompanyStatuses = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        var res, e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPI */ .F)("".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/statuses"))
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        res.statuses
                    ];
                case 2:
                    e = _state.sent();
                    (0,_log__WEBPACK_IMPORTED_MODULE_4__/* .printError */ .O)(e);
                    return [
                        2,
                        []
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getCompanyStatuses() {
        return _ref.apply(this, arguments);
    };
}();
var getCompanyContactPerson = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(ctx, shortname) {
        var e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAuthAPI */ .rO)(ctx, "".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/pages/companies/").concat(shortname, "/company_contact_person"))
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
                case 2:
                    e = _state.sent();
                    (0,_log__WEBPACK_IMPORTED_MODULE_4__/* .printError */ .O)(e);
                    return [
                        2,
                        {
                            contactPerson: null
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getCompanyContactPerson(ctx, shortname) {
        return _ref.apply(this, arguments);
    };
}();
var getContactPersons = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        var e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPI */ .F)("".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/users"))
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
                case 2:
                    e = _state.sent();
                    (0,_log__WEBPACK_IMPORTED_MODULE_4__/* .printError */ .O)(e);
                    return [
                        2,
                        {
                            users: []
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getContactPersons() {
        return _ref.apply(this, arguments);
    };
}();
var getCompanyMemo = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(ctx, shortname) {
        var e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAuthAPI */ .rO)(ctx, "".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/pages/companies/").concat(shortname, "/company_memo"))
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
                case 2:
                    e = _state.sent();
                    (0,_log__WEBPACK_IMPORTED_MODULE_4__/* .printError */ .O)(e);
                    return [
                        2,
                        {
                            memo: null
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getCompanyMemo(ctx, shortname) {
        return _ref.apply(this, arguments);
    };
}();
var saveCompanyMemo = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(shortname, content, callback) {
        var e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPI */ .F)("".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/pages/companies/").concat(shortname, "/company_memo"), {
                            method: "PUT",
                            credentials: "include",
                            body: JSON.stringify({
                                content: content
                            })
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
                case 2:
                    e = _state.sent();
                    (0,_log__WEBPACK_IMPORTED_MODULE_4__/* .printError */ .O)(e);
                    callback();
                    return [
                        2,
                        null
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function saveCompanyMemo(shortname, content, callback) {
        return _ref.apply(this, arguments);
    };
}();
var registerCompanyStatus = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(shortname, statusId) {
        var e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPIWithNoContent */ .bU)("".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/companies/").concat(shortname, "/status"), {
                            method: "PUT",
                            credentials: "include",
                            body: JSON.stringify({
                                id: statusId
                            })
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    e = _state.sent();
                    (0,_log__WEBPACK_IMPORTED_MODULE_4__/* .printError */ .O)(e);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function registerCompanyStatus(shortname, statusId) {
        return _ref.apply(this, arguments);
    };
}();
var deleteCompanyStatus = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(shortname) {
        var e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPIWithNoContent */ .bU)("".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/companies/").concat(shortname, "/status"), {
                            method: "DELETE",
                            credentials: "include"
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    e = _state.sent();
                    (0,_log__WEBPACK_IMPORTED_MODULE_4__/* .printError */ .O)(e);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function deleteCompanyStatus(shortname) {
        return _ref.apply(this, arguments);
    };
}();
var registerCompanyContactPerson = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(shortname, userId, callback) {
        var e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPIWithNoContent */ .bU)("".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/companies/").concat(shortname, "/contact_person"), {
                            method: "PUT",
                            credentials: "include",
                            body: JSON.stringify({
                                id: userId
                            })
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    e = _state.sent();
                    (0,_log__WEBPACK_IMPORTED_MODULE_4__/* .printError */ .O)(e);
                    callback();
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function registerCompanyContactPerson(shortname, userId, callback) {
        return _ref.apply(this, arguments);
    };
}();
var deleteCompanyContactPerson = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(shortname, callback) {
        var e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPIWithNoContent */ .bU)("".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/companies/").concat(shortname, "/company_contact_person"), {
                            method: "DELETE",
                            credentials: "include"
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    e = _state.sent();
                    (0,_log__WEBPACK_IMPORTED_MODULE_4__/* .printError */ .O)(e);
                    callback();
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function deleteCompanyContactPerson(shortname, callback) {
        return _ref.apply(this, arguments);
    };
}();
var registerFirstInterviewDate = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(shortname, firstInterviewDate) {
        var e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPIWithNoContent */ .bU)("".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/companies/").concat(shortname, "/first_interview_date"), {
                            method: "PUT",
                            body: JSON.stringify({
                                firstInterviewDate: firstInterviewDate
                            })
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    e = _state.sent();
                    (0,_log__WEBPACK_IMPORTED_MODULE_4__/* .printError */ .O)(e);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function registerFirstInterviewDate(shortname, firstInterviewDate) {
        return _ref.apply(this, arguments);
    };
}();
var deleteFirstInterviewDate = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(shortname) {
        var e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPIWithNoContent */ .bU)("".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/companies/").concat(shortname, "/first_interview_date"), {
                            method: "DELETE"
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    e = _state.sent();
                    (0,_log__WEBPACK_IMPORTED_MODULE_4__/* .printError */ .O)(e);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function deleteFirstInterviewDate(shortname) {
        return _ref.apply(this, arguments);
    };
}();
var addMyLabel = function(shortname, myLabelId, user) {
    return (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPIRaw */ .RH)("".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/v1/companies/").concat(shortname, "/my_label"), {
        method: "PUT",
        body: JSON.stringify({
            myLabelId: myLabelId
        })
    }).then(function(r) {
        return (0,_tracking__WEBPACK_IMPORTED_MODULE_1__/* .trackEvent */ .L9)(user, _tracking__WEBPACK_IMPORTED_MODULE_1__/* .SUM_OF_MYLABEL_SETTING */ .MM), r;
    }).catch(_log__WEBPACK_IMPORTED_MODULE_4__/* .printError */ .O);
};
var removeMyLabel = function(shortname, myLabelId, user) {
    return (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .callAPIRaw */ .RH)("".concat(_common__WEBPACK_IMPORTED_MODULE_0__/* .basePath */ .sb, "/v1/companies/").concat(shortname, "/my_label"), {
        method: "DELETE",
        body: JSON.stringify({
            myLabelId: myLabelId
        })
    }).then(function(r) {
        return (0,_tracking__WEBPACK_IMPORTED_MODULE_1__/* .trackEvent */ .L9)(user, _tracking__WEBPACK_IMPORTED_MODULE_1__/* .SUM_OF_MYLABEL_SETTING */ .MM), r;
    }).catch(_log__WEBPACK_IMPORTED_MODULE_4__/* .printError */ .O);
};


/***/ })

}]);